export type TrendSeverityTone = "high" | "moderate" | "low";
export type TrendTone = "red" | "orange" | "green";

export type AssessmentType = "GAD7" | "PHQ9" | "SOWS";

export interface AssessmentScoreEntry {
  date: string;
  type: AssessmentType;
  score: number;
}

export interface TrendCard {
  id: string;
  label: string;
  severity: string;
  severityTone: TrendSeverityTone;
  tone: TrendTone;
  title: string;
  description: string;
  sparkline: string;
  sparklineFill: string;
  strokeColor: string;
  fillColor: string;
}

export interface Alert {
  id: number;
  title: string;
  date: string;
  value: string;
  severity: "Critical" | "High" | "Moderate";
}

export interface AcuteMetric {
  id: string;
  label: string;
  icon: string;
  value: string;
  sevenDay: string;
  thirtyDay: string;
  color: string;
}

export interface ComparisonRow {
  domain: string;
  values: [string, string, string];
  tones: [string, string, string];
}

export interface Dashboard2Status {
  lastSurvey: string;
  lastWearableSync: string;
  dataCompletenessLabel: string;
  dataCompletenessValue: string;
}

export interface Dashboard2Deviation {
  message: string;
}

export interface TrendOverview {
  sows: string;
  cravings: string;
  sleep: string;
}

export interface Dashboard2Snapshot {
  status: Dashboard2Status;
  deviation: Dashboard2Deviation;
  trendCards: TrendCard[];
  safetyAlerts: Alert[];
  acuteMetrics: AcuteMetric[];
  trendSummary: string[];
  trendOverview: TrendOverview;
  chartAxisDates: string[];
  comparisonRows: ComparisonRow[];
  synopsis: string;
  /** Raw per-assessment score entries used for the normalized Trend Overview chart. */
  assessmentScores?: AssessmentScoreEntry[];
}

export const createEmptyDashboard2Snapshot = (): Dashboard2Snapshot => ({
  status: {
    lastSurvey: "",
    lastWearableSync: "",
    dataCompletenessLabel: "",
    dataCompletenessValue: ""
  },
  deviation: {
    message: ""
  },
  trendCards: [],
  safetyAlerts: [],
  acuteMetrics: [],
  trendSummary: [],
  trendOverview: {
    sows: "",
    cravings: "",
    sleep: ""
  },
  chartAxisDates: [],
  comparisonRows: [],
  synopsis: "",
  assessmentScores: []
});
